export type Theme = "dark" | "light" | "system";

const STORAGE_KEY = "mayflower-theme";
const DEFAULT_THEME: Theme = "dark";

let initialized = false;

export function getEffectiveTheme(pref: Theme): "dark" | "light" {
  if (pref === "system") {
    return globalThis.matchMedia("(prefers-color-scheme: light)").matches
      ? "light"
      : "dark";
  }
  return pref;
}

function applyTheme(pref: Theme) {
  const effective = getEffectiveTheme(pref);
  document.documentElement.dataset.theme = effective;
}

export function getTheme(): Theme {
  return (localStorage.getItem(STORAGE_KEY) as Theme) ?? DEFAULT_THEME;
}

export function setTheme(pref: Theme) {
  localStorage.setItem(STORAGE_KEY, pref);
  applyTheme(pref);
}

export function initTheme() {
  if (initialized) return;
  initialized = true;

  const stored = getTheme();
  applyTheme(stored);

  globalThis
    .matchMedia("(prefers-color-scheme: light)")
    .addEventListener("change", () => {
      const current = getTheme();
      if (current === "system") applyTheme("system");
    });
}
